import React, {useEffect} from 'react';
import {useBlog, useGetBlog} from "../stores/publicStore";
import Seo from "../utils/Seo";

const BlogDetail = () => {
    const blog = useGetBlog();
    const blogs = useBlog();
    useEffect(() => {
        void blog();
    }, [blog]);
    return (
        <>
            <Seo
                title="Блог о недвижимости в Кыргызстане | Aluu Satuu "
                description="Новости, советы и статьи о недвижимости в Кыргызстане от агентства Aluu Satuu. Актуальная информация для покупателей, продавцов и арендаторов."
                url={typeof window !== 'undefined' ? window.location.href : ''}
                image="/image.png"
            />
        <div>
            <div className="bg-[#F7F7F7]">
                <div className="container mx-auto min-h-[70vh] px-4 py-8">
                    <h1 className="text-3xl font-bold mb-6 text-center">Блог</h1>
                    <div className="flex justify-center flex-wrap gap-8">
                        {blogs.map((post) => {
                            const paragraphs = post.description.split(/\r?\n/);
                            return (
                                <div
                                    key={post.id}
                                    className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
                                >
                                    <img
                                        src={post.image}
                                        alt={post.title}
                                        className="w-full h-auto object-cover"
                                    />
                                    <div className="p-4 flex flex-col justify-between">
                                        <h2 className="text-xl font-semibold mb-2">{post.title}</h2>
                                        {paragraphs.map((para, i) => (
                                            <p key={i} className='mt-1 text-[#212529]'>{para.trim()}</p>
                                        ))}
                                        <p className="text-sm mt-3 text-gray-400">{post.date}</p>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default BlogDetail;